export default class StatusLaudo {
    static get CONFORME() {
        return 1;
    }

    static get INCONFORME() {
        return 2;
    }

    static get INCONCLUSIVO() {
        return 3;
    }

    static get NAO_APLICADO() {
        return 4;
    }

    static getByName(name) {
        if (!name) return;
        name = name.toUpperCase();
        return StatusLaudo[name];
    }
}
